module.exports = __webpack_public_path__ + "img/us.2a37d79a.svg";